/**
 * The app's one breakpoint scale: MUI's defaults, stated explicitly so the theme, the JS media
 * queries (`hooks/responsiveLayout.ts`) and the CSS `@media` widths all read the same numbers.
 *
 * `md` is the phone/desktop line: below it is mobile, at or above it desktop. There is no tablet
 * tier. `sm` and `lg` exist for component-level compaction inside one of those two layouts; `xl`
 * is MUI's and is used only for very wide toolbars. See docs/design-system.md section 3.
 *
 * CSS writes these as `max-width: <n - 0.05>px` / `min-width: <n>px` (MUI's own `down`/`up`
 * form); `check-structure.sh` rejects any other `@media` width.
 */
export const BREAKPOINTS = { xs: 0, sm: 600, md: 900, lg: 1200, xl: 1536 } as const;

export type Breakpoint = keyof typeof BREAKPOINTS;
